import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TipoEquipamientoLaboratorio } from './tipos-equipamiento-laboratorio.model';
import { environment } from 'projects/registro-personas-empresas/src/environments/environment';

@Injectable({ providedIn: 'root' })
export class TiposEquipamientoLaboratorioService {
  constructor(private httpClient: HttpClient) {}

  getTipoEquipamientoLaboratorio(): Observable<TipoEquipamientoLaboratorio[]> {
    return this.httpClient.get<TipoEquipamientoLaboratorio[]>(
      `${environment.apiUrl}/tiposEquipamientoLaboratorio/`
    );
  }
}
